export { fetchForgeContextToken } from './forge-context-token';
